import { API_USER_SERVICE } from "../config/Constants";
import { IInventoryRequestDTO,  IInventoryFilterDTO, IBuildingDimensionsDTO, IRoomTemporaryDimensionsDTO } from "../interfaces/Inventory";
import { getRequest, postRequest, putRequest } from "./Rest";
import axios from "axios";

export const createInventory = async (dto: IInventoryRequestDTO, image?: File) => {
    const path = `${API_USER_SERVICE}/inventory`;
    
    if (image) {
        const formData = new FormData();
        formData.append("data", new Blob([JSON.stringify(dto)], { type: "application/json" }));
        formData.append("image", image);
        
        const token = sessionStorage.getItem("token");
        const response = await axios.post(path, formData, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "multipart/form-data",
            },
        });
        return response.data;
    } else {
        const response = await postRequest(path, dto);
        return response;
    }
};

export const updateInventory = async (id: number, dto: IInventoryRequestDTO, image?: File) => {
    const path = `${API_USER_SERVICE}/inventory/${id}`;
    
    if (image) {
        const formData = new FormData();
        formData.append("data", new Blob([JSON.stringify(dto)], { type: "application/json" }));
        formData.append("image", image);
        
        const token = sessionStorage.getItem("token");
        const response = await axios.put(path, formData, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "multipart/form-data",
            },
        });
        return response.data;
    } else {
        const response = await putRequest(path, dto);
        return response;
    }
};

export const getTypesWithItems = async () => {
    const path = `${API_USER_SERVICE}/item-type/with-items`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};
export const getTypesWithItemsAvailable = async () => {
    const path = `${API_USER_SERVICE}/item-type/with-transferred-items`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};
export const getTypesWithItemsAvailablePublic = async (companyId: number) => {
    const path = `${API_USER_SERVICE}/item-type/with-transferred-items/${companyId}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};
export const getCategoriesByTypeId = async (typeId: number) => {
    const path = `${API_USER_SERVICE}/category/byType/${typeId}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};
export const getItemsByCategoryId = async (categoryId: number) => {
    const path = `${API_USER_SERVICE}/item/byCategory/${categoryId}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};

export const getAvailableForTemporary = async (dto: IBuildingDimensionsDTO) => {
    const path = `${API_USER_SERVICE}/building/temporary?length=${dto.length}&width=${dto.width}&height=${dto.height}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};

export const getRoomsAvailableForTemporary = async (dto: IRoomTemporaryDimensionsDTO) => {
    const path = `${API_USER_SERVICE}/room/temporary?length=${dto.length}&width=${dto.width}&height=${dto.height}&buildingId=${dto.buildingId}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};

export const getInventoryById = async (id: number) => {
    const path = `${API_USER_SERVICE}/inventory/${id}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};

export const getInventoryWithFilters = async (dto: IInventoryFilterDTO) => {
    const { searchTerm, statuses, types, itemTypeIds, page = 0, size = 7 } = dto;
    
    let path = `${API_USER_SERVICE}/inventory?page=${page}&size=${size}`;
    
    if (searchTerm) {
        path += `&searchTerm=${encodeURIComponent(searchTerm)}`;
    }
    
    if (statuses && statuses.length > 0) {
        statuses.forEach(status => {
            path += `&statuses=${status}`;
        });
    }
    
    if (types && types.length > 0) {
        types.forEach((type: string) => {
            path += `&types=${type}`;
        });
    }
    
    if (itemTypeIds && itemTypeIds.length > 0) {
        itemTypeIds.forEach(id => {
            path += `&itemTypeIds=${id}`;
        });
    }
    
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};